import { defineComponent as B, ref as u, watchEffect as C, openBlock as r, createBlock as f, Teleport as h, unref as n, createElementBlock as d, renderSlot as w, normalizeProps as D, guardReactiveProps as N, createVNode as P, Transition as j, mergeProps as p, withCtx as E, resolveDynamicComponent as I, createCommentVNode as m, nextTick as v } from "vue";
import { DefaultModalOutlet as M, useModalOutlet as T } from "./composition/useModalOutlet.js";
const V = ["id"], O = /* @__PURE__ */ B({
  __name: "v-modal-outlet",
  props: {
    transitionName: { default: "v-dialog" },
    containerId: { default: M }
  },
  setup(R) {
    const y = R, a = u(), t = u(!1), g = document.body, { currentDialog: e, isPending: k } = T(y.containerId);
    async function c() {
      var o, l;
      (o = a.value) != null && o.open || (t.value = !0, await v(), (l = a.value) == null || l.showModal());
    }
    function i() {
      t.value || c();
    }
    function s() {
      _();
    }
    async function _() {
      var o;
      await v(), !e.value && ((o = a.value) == null || o.close(), t.value = !1);
    }
    return C(() => {
      (e.value || k.value) && t.value === !1 && c();
    }), (o, l) => (r(), f(h, { to: n(g) }, [
      t.value ? (r(), d("dialog", {
        key: 0,
        ref_key: "containerRef",
        ref: a,
        id: o.containerId.description
      }, [
        w(o.$slots, "default", D(N({ onBeforeEnter: i, onAfterLeave: s, currentDialog: n(e) })), () => [
          P(j, p({
            ref: "transitionRef",
            name: o.transitionName,
            appear: ""
          }, { onAfterLeave: s, onBeforeEnter: i, onBeforeAppear: i }), {
            default: E(() => [
              n(e) ? (r(), d("div", {
                class: "v-modal-inner",
                key: n(e).id
              }, [
                (r(), f(I(n(e).component), p(n(e).props, {
                  onResolve: n(e).onResolve,
                  onReject: n(e).onReject
                }), null, 16, ["onResolve", "onReject"]))
              ])) : m("", !0)
            ]),
            _: 1
          }, 16, ["name"])
        ])
      ], 8, V)) : m("", !0)
    ], 8, ["to"]));
  }
});
export {
  O as default
};
